module.exports = __webpack_public_path__ + "img/conhome-logo-white-final.12c12a17.svg";